// markdown-exit default options

import type { Preset } from '../types/preset'
import { defaultOptions } from '../parser'

const defaultPreset: Preset = {
  options: {
    ...defaultOptions,
  },

  components: {
    core: {},
    block: {},
    inline: {},
  },
}

export default defaultPreset
